import { format, parse } from "date-fns";

const mapAttributes = ["inventory-blockings", "companyAddresses", "campaigns", "companies", "users"];

export default {
  mapDataForEndpoint(resource, data) {
    if (resource === "communication-gateways") {
      if (typeof data.options === "string" && data.options.length >= 0) {
        data.options = JSON.parse(data.options);
      }
    }
    // transforms { tax_ids: { vat: 'DE123456789' }} to { tax_ids_key_value: [{ key: 'vat', value: 'DE123456789' }] }
    if (resource === "useraddresses" || resource === "companyAddresses") {
      data.tax_ids = {};
      if (data.tax_ids_key_value.length > 0) {
        data.tax_ids_key_value.forEach(taxId => (data.tax_ids[taxId.key] = taxId.value));
      }
      delete data.tax_ids_key_value;
    }
    if (mapAttributes.includes(resource)) {
      data.attributes = {};
      if (data.attributes_key_value.length > 0) {
        data.attributes_key_value.forEach(taxId => (data.attributes[taxId.key] = taxId.value));
      }
      delete data.attributes_key_value;
    }
    if (resource === "shipping/calculations") {
      data = JSON.parse(data.payload);
    }
    if (resource === "campaigns") {
      // We need to strip the time/timezone offset to make sure, the date will be send "as is". The actual timezone comes
      // from the "date_timezone" field
      if (data.all_day) {
        if (data.date_from instanceof Date) data.date_from = format(data.date_from, "yyyy-MM-dd");
        if (data.date_to instanceof Date) data.date_to = format(data.date_to, "yyyy-MM-dd");
      } else {
        data.date_from = format(data.date_from, "yyyy-MM-dd HH:mm:ss");
        data.date_to = format(data.date_to, "yyyy-MM-dd HH:mm:ss");
      }
    }
    return data;
  },
  mapDataForForm(resource, data) {
    // transforms { tax_ids_key_value: [{ key: 'vat', value: 'DE123456789' }] } to { tax_ids: { vat: 'DE123456789' }}
    if (resource === "useraddresses" || resource === "companyAddresses") {
      data.tax_ids_key_value = [];
      if (data.tax_ids) {
        Object.keys(data.tax_ids).forEach(key => data.tax_ids_key_value.push({ key, value: data.tax_ids[key] }));
      }
      delete data.tax_ids;
    }

    if (mapAttributes.includes(resource)) {
      data.attributes_key_value = [];
      if (data.attributes) {
        Object.keys(data.attributes).forEach(key => data.attributes_key_value.push({ key, value: data.attributes[key] }));
      }
      delete data.attributes;
    }

    if (resource === "campaigns") {
      if (data.all_day) {
        data.date_to = parse(data.date_to.substring(0, 10), "yyyy-MM-dd", new Date());
        data.date_from = parse(data.date_from.substring(0, 10), "yyyy-MM-dd", new Date());
      } else {
        // We need to parse the date from the API without the timezone offset, so it's parsed in the local timezone
        data.date_to = parse(data.date_to.substring(0, 19), "yyyy-MM-dd'T'HH:mm:ss", new Date());
        data.date_from = parse(data.date_from.substring(0, 19), "yyyy-MM-dd'T'HH:mm:ss", new Date());
      }
    }
    return data;
  }
};
